import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useAuth } from "@/features/auth/use-auth";
import { useFirebase } from "@/hooks/use-firebase";
import {
  listUserInvitations,
  subscribeToUserInvitations,
} from "@/services/member-service";

export const invitationKeys = {
  user: (email: string) => ["invitations", email.toLocaleLowerCase()] as const,
};

export function useInvitationNotifications() {
  const { user } = useAuth();
  const { db } = useFirebase();
  const queryClient = useQueryClient();
  const email = user?.email?.toLocaleLowerCase() ?? "";
  const key = invitationKeys.user(email);
  const query = useQuery({
    queryKey: key,
    queryFn: () => listUserInvitations(db, email),
    enabled: Boolean(email),
  });

  useEffect(() => {
    if (!email) return;
    return subscribeToUserInvitations(db, email, (invitations) => {
      queryClient.setQueryData(invitationKeys.user(email), invitations);
    });
  }, [db, email, queryClient]);

  return query;
}
